<template>
    <div class="ui-tabs" :class="{ 'disable-button-mode': disableButtonMode, 'sm': size == 'sm', 'lg': size == 'lg' }">
        <!-- 
            UI TABS
            
            Versión 1.2

            Permite que se pase cada elemento de options en formato de objeto de estructura: 
                {
                    key:'null', 
                    label: ''
                }
            
            Versión 1.1

            Ajustes dinámicos de SCSS, también permite el parámetro autoSelectFirst.

            @Author Daniel Lepe
            @Date 10/12/2024
            
            Versión 1.0
            
            @Author Daniel Lepe
            @Date 28/04/2022
          -->
        <div class="tab-header highlightOnHover" v-for="(item, $index) in operationalOptions" :key="$index"
            :class="{ active: checkIsActive(item) }" @click.prevent="triggerClick(item)">
            <!-- <div class="highlightOnHover" ></div> -->
            {{ (typeof item == 'object' && 'label' in item) ? item.label : item }}
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    name: 'ui-tabs',
    props: {
        size: {
            type: String,
            default: 'md',
        },
        disableButtonMode: {
            type: Boolean,
            default: false
        },
        autoSelectFirst: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Number, String, Boolean],
            default: null
        },
        options: {
            type: [Array, String],
            default: () => {
                return ['Activo']
            }
        },
    },
    computed: {
        operationalOptions() {
            if (_.isArray(this.options)) {
                return this.options
            } else if (_.isString(this.options)) {
                return this.options.split(', ')
            } else {
                return []
            }
        }
    },
    methods: {
        checkIsActive(item) {
            if (_.isObject(item) && 'route' in item) {
                return this.$route.path == item.route
            }
            else if (_.isObject(item) && 'key' in item) {
                return this.value == item.key
            }
            else {
                return this.value == item
            }
        },
        triggerClick(item) {
            if (_.isObject(item) && 'key' in item || _.isString(item)) {
                this.$emit('input', (_.isObject(item) && 'key' in item) ? item.key : item)
            } else if (_.isObject(item) && 'route' in item) {
                this.$router.push(item.route)
            } else {
                console.warn('Invalid item format. Expected an object with a "key" property or a string.')
            }
            // this.$emit('input', (typeof item == 'object' && 'key' in item) ? item.key : item)
        }
    },
    beforeMount() {
        if (!this.value && this.autoSelectFirst) {
            const firstOption = this.options[0];
            if (typeof firstOption == 'object' && 'key' in firstOption) {
                this.$emit('input', firstOption.key)
            } else {
                this.$emit('input', firstOption)
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables';

.ui-tabs {
    display: flex;
    flex-flow: row;
    border-radius: 0.25rem;
    overflow: clip;
    border: $primary-dark-border;
    font-family: "Play", sans-serif;
    font-size: 1.0rem;
    cursor: pointer;

    &.sm {
        font-size: 0.9rem;
    }

    &.lg {
        font-size: 1.25rem;
    }

    &.disable-button-mode {
        display: inline-flex;
        flex-flow: row;
        width: 100%;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 0;
        border-bottom: $secondary-border;

        .tab-header {
            flex: 0 1 auto;
            border-bottom-left-radius: 0rem;
            border-bottom-right-radius: 0rem;
            border-bottom: none;
            white-space: nowrap;
            // color: $primary;
            // background: $soft-gray;
            // cursor: not-allowed;

            &.active {
                color: $secondary;
                border: $secondary-border;
                border-bottom: none;
                // background: $soft-gray;
            }
        }
    }

    .tab-header {
        flex: 1 0 auto;
        color: white;
        text-align: center;
        padding: 0.5em 1em;
        // cursor: pointer;
        // border-radius: 0.25rem;
        overflow: hidden;

        &.active {
            // color: black;
            border: $secondary-border;
            color: $secondary;
        }
    }

    @media screen and (max-width: 991px) {
        font-size: 0.75rem;
    }
}
</style>